var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.138,
    height: 17.557,
    viewBox: "0 0 54.138 17.557",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "visa_logo",
    d: "M38.766,4.381,39.4.739A12.744,12.744,0,0,0,35.424,0c-2.191,0-7.4.956-7.4,5.616,0,4.381,6.107,4.438,6.107,6.738s-5.482,1.891-7.29.439L26.185,16.6a12.411,12.411,0,0,0,4.986.956c3.012,0,7.564-1.56,7.564-5.807s-6.164-4.821-6.164-6.738,4.3-1.674,6.195-.63m6.453,6.882,2.32-6.35,1.307,6.35Zm4.862,6h4.056L50.6.3h-3.55a2.036,2.036,0,0,0-2.041,1.266l-6.588,15.7h4.6l.92-2.521H49.56l.517,2.521ZM15.335.3,11.124,11.977l-.5-2.511h0L9.135,1.839A1.894,1.894,0,0,0,7.037.31H.083L0,.6A16.587,16.587,0,0,1,4.619,2.537L8.458,17.278h4.6L20.089.3Zm8.133,16.968H19.05L21.809.3h4.418Z",
    fill: "#1434cb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogo);
export default __webpack_public_path__ + "static/media/visa_logo.4c0bb535ecb11be47fd2220eab606ee1.svg";
export { ForwardRef as ReactComponent };